import { render, staticRenderFns } from "./MatrixView.vue?vue&type=template&id=4518d5aa&scoped=true&"
import script from "./MatrixView.vue?vue&type=script&lang=js&"
export * from "./MatrixView.vue?vue&type=script&lang=js&"
import style0 from "./MatrixView.vue?vue&type=style&index=0&id=4518d5aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4518d5aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VImg,VSimpleTable,VSkeletonLoader,VTooltip})
